/**
 * Current UI language as a module singleton, so pure display helpers (nodeName)
 * can pick the right name field without threading the locale through every
 * component. Set once from App whenever the language changes — mirrors how
 * services/api.tsx already tracks the request language.
 *
 * English uses the ASCII `normalizedName`; every other language uses the native
 * `name` (Telugu/Kannada/… script).
 */
import { toLanguageCode } from './languages';

let current = 'en';

/** Accepts either a language name ("Telugu") or a code ("te"). */
export function setDisplayLanguage(nameOrCode: string | undefined | null): void {
  current = toLanguageCode(nameOrCode);
}

export function getDisplayLanguage(): string {
  return current;
}
